<script>
import Validation from '@/plugins/validation'
import { Input, Checkbox, AutocompleteSelect } from '@/components/formelements'
// import DataTable from '@/components/DataTable'
import { mapState } from 'vuex'

export default {
  name: 'Home',
  data() {
    return {
      ...Validation,
      items: [
        {
          text: 'active',
          value: "1",
        },
        {
          text: 'deleted/inactive',
          value: "901",
        },
      ],
    }
  },
  async mounted(){
    await this.$store.dispatch('search/SET_STATUS_TYPES')
    await this.$store.dispatch('siteFilter/GET_SITE_TYPES')
    await this.$store.dispatch('merchant/GET_COUNTRIES')
    await this.$store.dispatch('merchant/GET_STATES', 1)
    await this.$store.dispatch('retailerTag/GET_LANGUAGES')
  },
  components: {
    Input,
    Checkbox,
    AutocompleteSelect,
    // DataTable
  },
  computed: {
    ...mapState({
      searched: state => state.search.searched,
      tableData: state => state.searchTableData.tableData,
      search: state => state.searchTableData.tableHeader,
      status: state => state.searchTableData.tableStatus
    }),
    oneCheckBoxChecked(){
      return [
        () => {
          return (this.$store.state.search.pRetailers || this.$store.state.search.retailers || this.$store.state.search.merchants) || 'Select at least one'
        },
      ]
    },

  },
  methods: {
    searchGo() {
      if(this.$refs.searchForm.validate()) {
        this.$store.dispatch('search/SEARCH_CLIENT')
      }
    },
  }
}
</script>

<template>
  <v-form ref="searchForm" @keyup.native.enter="searchGo">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col  cols="12" md="5" sm="12"  >
          <Input form="search" field="search" :maxlength="128" :rules="[...required]" placeholder="" label="Search" />
        </v-col>
        <v-col class="d-flex justify-center" cols="12" md="1" >
          <h2 class="pb-6 mx-auto">within</h2>
        </v-col>
        <v-col cols="12" md="2" >
          <AutocompleteSelect form="search" field="status" color="accent" :rules="[...required]" placeholder="" label="Status" :items="items" />
        </v-col>
        <v-col class="d-flex flex-column" cols="12" md="2" >
          <Checkbox :rules="[...oneCheckBoxChecked]" class="ml-5" form="search" field="pRetailers" color="accent" placeholder="" label="PRetailers"/>
          <Checkbox :rules="[...oneCheckBoxChecked]" class="ml-5" form="search" field="retailers" color="accent" placeholder="" label="Retailers"/>
          <Checkbox :rules="[...oneCheckBoxChecked]" class="ml-5" form="search" field="merchants" color="accent" placeholder="" label="Merchants"/>
        </v-col>
        <v-col class="d-flex mb-6" cols="12" md="2" >
          <v-btn width="150px" @click="searchGo" depressed color="accent">
            Search <v-icon right>mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="searched && tableData[0].display" cols="12">
          <v-card>
            <v-card-title>
              {{ +status == 1? "Active": "Inactive"  }} {{ tableData[0].name }} results for {{ search }}
              <v-spacer></v-spacer>
              Now displaying {{ tableData[0].tData.length }} matching {{ tableData[0].name }}(s)
            </v-card-title>
            <v-data-table
              :headers="tableData[0].headers"
              :items="tableData[0].tData"
              :items-per-page="10"
            >
              <template v-slot:item.MerchantID= "{ item }" >
                <span>
                  <router-link :to="{ name: 'Merchant', params: { id: item.MerchantID } }">
                    {{ item.MerchantID }}
                  </router-link>
                </span>
              </template>
              <template v-slot:item.ID= "{ item }" >
                <span>
                  <router-link :to="{ name: 'Pretailer', params: { id: item.ID } }">
                    {{ item.ID }}
                  </router-link>
                </span>
              </template>
              <template v-slot:item.RetailerID= "{ item }" >
                <span>
                  <router-link :to="{ name: 'Retailer', params: { id: item.RetailerID } }">
                    {{ item.RetailerID }}
                  </router-link>
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="searched && tableData[1].display" cols="12">
          <v-card>
            <v-card-title>
              {{ +status == 1? "Active": "Inactive"  }} {{ tableData[1].name }} results for {{ search }}
              <v-spacer></v-spacer>
              Now displaying {{ tableData[1].tData.length }} matching {{ tableData[1].name }}(s)
            </v-card-title>
            <v-data-table
              :headers="tableData[1].headers"
              :items="tableData[1].tData"
              :items-per-page="10"
            >
              <template v-slot:item.MerchantID= "{ item }" >
                <span>
                  <router-link :to="{ name: 'Merchant', params: { id: item.MerchantID } }">
                    {{ item.MerchantID }}
                  </router-link>
                </span>
              </template>
              <template v-slot:item.ID= "{ item }" >
                <span>
                  <router-link :to="{ name: 'Retailer', params: { id: item.ID } }">
                    {{ item.ID }}
                  </router-link>
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="searched && tableData[2].display" cols="12">
          <v-card>
            <v-card-title>
              {{ +status == 1? "Active": "Inactive"  }} {{ tableData[2].name }} results for {{ search }}
              <v-spacer></v-spacer>
              Now displaying {{ tableData[2].tData.length }} matching {{ tableData[2].name }}(s)
            </v-card-title>
            <v-data-table
              :headers="tableData[2].headers"
              :items="tableData[2].tData"
              :items-per-page="10"
            >
              <template v-slot:item.ID= "{ item }" >
                <span>
                  <router-link :to="{ name: 'Merchant', params: { id: item.ID} }">
                    {{ item.ID}}
                  </router-link>
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
